import Image from "next/legacy/image";
import Link from "@/utils/link";

import HomeHeader from "@/components/home/HomeHeader";
import { fetchGraphql } from "@/utils/query";

import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import Breadcrumbs from "@/components/common/Breadcrumbs";
import { imageLoader } from "@/utils/image";

import HomeSearch from "@/components/home/HomeSearch";

const GuidebooksPage = ({ guidebooks }) => {
    return (
        <div className="h-screen bg-gray-50">
            <HomeHeader fixed />

            <div className="container mx-auto pt-16 sm:pt-20 pb-4 px-4 sm:px-16">
                <Breadcrumbs
                    links={[
                        { name: "Resources", href: "/resources" },
                        { name: "Guidebooks", href: "/resources/guidebooks" },
                    ]}
                />
            </div>

            <div>
                <div className="hidden sm:block">
                    <div className="relative w-full h-40 sm:h-96 bg-black">
                        <Image
                            loader={imageLoader}
                            src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-articles"
                            alt="purple-door-finders-articles-for-memory-care"
                            layout="fill"
                            objectFit="cover"
                            objectPosition="0px -200px"
                            priority
                            unoptimized={false}
                            className="opacity-80"
                        />

                        <div className="flex justify-center">
                            <h1 className="absolute px-8 top-12 sm:top-24 text-3xl sm:text-5xl text-white font-headline font-bold">
                                Guidebooks
                            </h1>

                            <div className="absolute bottom-12 flex justify-center">
                                <HomeSearch
                                    inputClassName="w-[280px] sm:w-[500px]"
                                    enableLocation={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sm:hidden">
                    <h1 className="px-4 text-3xl text-primary-500 font-headline font-bold">
                        Guidebooks
                    </h1>

                    <div className="px-4">
                        <HomeSearch
                            inputClassName="w-[calc(100%-64px)] max-w-[500px]"
                            enableLocation={false}
                        />
                    </div>
                </div>

                <div className="container mx-auto my-12 px-4 sm:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {guidebooks.map((guidebook) => (
                            <GuidebookCard
                                key={guidebook.guidebookId}
                                guidebook={guidebook}
                                imageHeight="h-40 xl:h-48"
                            />
                        ))}
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

const GuidebookCard = ({ guidebook, imageHeight }) => {
    return (
        <div className="border border-gray-200 rounded shadow hover:shadow-xl hover:bg-gray-100">
            <Link href={"/resources/guidebooks/" + guidebook.guidebookId}>
                <a className="">
                    {guidebook.mainImageUrl ? (
                        <img
                            src={guidebook.mainImageUrl}
                            className={`w-full ${imageHeight} object-cover`}
                        />
                    ) : (
                        <div className={`w-full ${imageHeight} bg-gray-200`}></div>
                    )}

                    <div className="relative w-full h-32 px-4 pb-2">
                        <h3 className="mt-1 font-headline font-bold text-gray-700">
                            {guidebook.name}
                        </h3>
                    </div>
                </a>
            </Link>
        </div>
    );
};

export const getStaticProps = async () => {
    const result = await fetchGraphql(`
        query {
            guidebooks {
                guidebookId
                name
                mainImageUrl
            }
        }
    `);

    return {
        props: {
            guidebooks:
                result.data && result.data.guidebooks && result.data.guidebooks.length > 0
                    ? result.data.guidebooks
                    : [],
        },
    };
};

export default GuidebooksPage;
